import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Card, CardContent, CardHeader, Grid2, IconButton, Stack } from '@mui/material'
import { BsFillPersonBadgeFill } from "react-icons/bs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MaterialTypography from '../../../components/MaterialTypography';
import MaterialBox from '../../../components/MaterialBox';
import MaterialInput from '../../../components/MaterialInput';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNotificationById, updateNotification } from '../GraphQl';
import BASEURL from '../../Utils/Baseurl';
import request from 'graphql-request';

const AddNotification = () => {
    const navigate = useNavigate();
    const params = useLocation();
    const ID = params.search.slice(1);

    const [togglePage, setTogglePage] = useState({
        view: false,
        edit: false,
    });

    const [notificationData, setNotificationData] = useState({
        type: '',
        task: '',
        message: '',

        typeStatus: "unchecked",
        taskStatus: "unchecked",
        messageStatus: "unchecked"
    });

    useEffect(() => {
        if (!togglePage.edit) {
          setTogglePage({ view: true, edit: false });
          fetchNotificationById();
        }
    }, []);

    useEffect(() => {
      handleMarkAsRead();
    },[]);
      
    //   By ID
    const fetchNotificationById = async () => {
      
        try {
          const variables = { id: parseInt(ID) };
          const res = await request(BASEURL, getNotificationById, variables);
          if (res.getNotificationById.success === true && res.getNotificationById.data) {
            const resdata = res.getNotificationById.data?.[0];
            
            setNotificationData({
              type: resdata?.notificationType || 'N/A',
              task: resdata?.task?.title || 'N/A',
              message: resdata?.message || 'N/A',

              typeStatus: resdata.notificationType ? "success" : "unchecked",
              taskStatus: resdata?.task?.title ? "success" : "unchecked",
              messageStatus: resdata?.message ? "success" : "unchecked"
            });
          }
        } catch(error){
          console.error('Error fetching notification', error); 
        }
    };  

    //Mark As Read Function
    const handleMarkAsRead = async () => {
      const values = {
        id: ID,
        isRead: true,
      }
      try{
        const response = await request(BASEURL, updateNotification, {
          input: values
        })
      }
      catch(error){
        console.error("Couldn't Update Data: ",error)
      }
    }


  return (
    <DashboardLayout>
    <Card>
      <CardHeader
        title={
          <>
            {togglePage.view === true ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Notification details
                  </MaterialTypography>
                </Stack>
              </Stack>
            ) : togglePage.edit === true ? (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Notification
                  </MaterialTypography>
                </Stack>
              </Stack>
            ) : (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" spacing={0}>
                    <IconButton
                     sx={{ mr: 1, mt: -0.7 }}
                     onClick={() => {
                       navigate("/notification");
                     }}
                   >
                     <ArrowBackIcon />
                   </IconButton> 
                  <MaterialTypography variant="h5" fontWeight="medium">
                    View Notification
                  </MaterialTypography>
                </Stack>
              </Stack>
            )}
          </>
        }
      />
      <CardContent sx={{ minHeight: "70vh" }}>
        <MaterialBox>
          <Stack direction="row" spacing={1}>
               <BsFillPersonBadgeFill style={{ fontSize: 20 }} />
                        <MaterialTypography
                          component="label"
                          variant="body2"
                          fontWeight="bold"
                        >
                          Notification Information
                        </MaterialTypography>
         
          </Stack>
        
          <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
              
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Notification Type
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="type"
                value={notificationData.type}
                disabled={togglePage?.view === true ? true : false}
                success={notificationData.typeStatus === "success"}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Task Title
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="task"
                value={notificationData.task}
                disabled={togglePage?.view === true ? true : false}
                success = {notificationData.taskStatus === "success"}
              />
            </Grid2>
          
            <Grid2 size={{ xs: 12, sm: 12 }}>
              
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Message
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="message"
                value={notificationData.message}
                success={notificationData.messageStatus === "success"}
                multiline
                rows={5}
                disabled={togglePage?.view === true ? true : false}
              />
            </Grid2>
          </Grid2>
        
        </MaterialBox>
      </CardContent>
    </Card>
  </DashboardLayout>
  )
}

export default AddNotification